import React, { Component } from 'react';

class CompanyHeader extends Component {

    render() {
        return (
            <>
                <p className="h3">Multiplex Limited</p>
                <address>
                    Kampala, Uganda<br/>
                    P.O. Box 3874 kampala<br/>
                    HOTLINE: 0312360100<br/>
                    multiplexug@gmail.com<br/>
                    TIN: 1000073445
                </address>
            </>
        );
    }
}

export default CompanyHeader;
